export default function Cta() {
  const goTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="container-site py-16 md:py-24">
      <div className="reveal relative overflow-hidden rounded-3xl border border-primary-400/30 bg-gradient-to-br from-background-100 via-background-100 to-primary-900/20 px-6 py-14 text-center md:px-12 md:py-20">
        <i className="ri-quill-pen-line absolute -left-4 top-4 rotate-[-12deg] text-7xl text-primary-500/15"></i>
        <i className="ri-artboard-2-line absolute bottom-4 right-6 rotate-6 text-7xl text-accent-500/15"></i>
        <i className="ri-shape-2-line absolute right-1/4 top-6 text-5xl text-secondary-500/15"></i>

        <div className="relative mx-auto max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-4 py-1.5 text-xs font-medium text-primary-300">
            <i className="ri-fire-fill"></i>
            现在开始，追更不孤单
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-950 md:text-5xl">
            叫上漫友，一起看漫画吧
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            打开178漫画网一起看漫画专区，选择心仪作品，创建同看房间，和漫友实时同步更新、边看边聊，从此追更有伴。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button type="button" className="btn-primary w-full sm:w-auto" onClick={() => goTo('#hot')}>
              <i className="ri-play-circle-fill text-lg"></i>
              立即开始同看
            </button>
            <button type="button" className="btn-ghost w-full sm:w-auto" onClick={() => goTo('#reviews')}>
              看看漫友口碑
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}